import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { EMPTY_OBJECT, FEATURES } from 'shared/utils/constants';
const EMPTY_ARRAY = [];
type featureType = keyof typeof FEATURES;
export function useFeatureFlags(): featureType[] {
  const businessId = useSelector((state: any) => {
    if (state.userPreferences?.currentBusinessId && state.userPreferences?.currentBusinessId !== '0') {
      return state.userPreferences?.currentBusinessId;
    } else {
      return state.public?.businessId;
    }
  });
  const subscriptionData = useSelector((state_0: any) => state_0.subscriptions?.data || EMPTY_OBJECT);
  const businessData = useSelector((state_1: any) => state_1.businesses.data);
  const business = businessData[businessId];
  const planData = useSelector((state_2: any) => state_2.plans?.data || EMPTY_OBJECT);
  const planFeatures = React.useMemo(() => {
    const subscriptions = Object.values<any>(subscriptionData);
    const subscription = subscriptions.filter(s => !['cancelled', 'unpaid'].includes(s.status)).find(s_0 => s_0.business_id === businessId);
    if (subscription) {
      const plan = planData[subscription.plan_id];
      if (!plan) {
        return [];
      }
      return plan.features;
    }
    return [];
  }, [businessId, planData, subscriptionData]);
  const featureFlags = React.useMemo(() => business?.feature_flags || EMPTY_ARRAY, [business?.feature_flags]);
  const finalFlags = React.useMemo(() => [...featureFlags, ...planFeatures], [featureFlags, planFeatures]);
  if (__TARGET_ENV__ !== 'production') {
    finalFlags.push('documents');
  }
  return finalFlags;
}
export function useHasFeature(feature) {
  const $ = _c(3);
  const featureFlags = useFeatureFlags();
  let t0;
  if ($[0] !== feature || $[1] !== featureFlags) {
    t0 = featureFlags.includes(feature);
    $[0] = feature;
    $[1] = featureFlags;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}